import cloud from "../cloud";

/**
 * 获取淘宝云空间文件的临时链接
 */
export default async function getCloudFileUrl(fileId: string) {
    try {
        // @ts-ignore
        const results = await cloud.file.getTempFileURL({
            fileId,
        });

        const url = results[0].url;

        return url;
    } catch (error) {
        return "";
    }
}
